<template>
  <v-tabs left>
    <v-tab>Edit HTML</v-tab>
    <v-tab>PREVIEW</v-tab>
    <v-tab-item>
      <v-row class="html_page_edit_css">
        <v-col cols="6">
          <v-row>
            <v-col>
              <p>HTML HEAD設定</p>
              <codemirror
                v-model="headContent"
                :options="cmOptionsHtml"
                @inputRead="inputted()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p>CSS設定</p>
              <codemirror
                v-model="cssContent"
                :options="cmOptionsCss"
                @inputRead="inputted()"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col>
              <p>HTML BODY設定</p>
              <codemirror
                v-model="bodyContent"
                class="codemirror_html_body_css"
                :options="cmOptionsHtml"
                @inputRead="inputted()"
              /> </v-col
          ></v-row>
        </v-col>
      </v-row>
    </v-tab-item>
    <v-tab-item>
      <preview-layout
        :id="id"
        :head-content="headContent"
        :body-content="bodyContent"
        :css-content="cssContent"
      />
    </v-tab-item>
  </v-tabs>
</template>
<script>
// import axios from 'axios'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
// language
import 'codemirror/mode/javascript/javascript.js'
// theme css
import 'codemirror/theme/monokai.css'
// require active-line.js
import 'codemirror/addon/selection/active-line.js'
// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js'
import 'codemirror/addon/search/searchcursor.js'
// hint
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/javascript-hint.js'
// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

import PreviewLayout from './PreviewLayout'
import { mapGetters } from 'vuex'

export default {
  name: 'EditHtmlArea',
  components: { codemirror, PreviewLayout },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data: () => {
    return {
      cmOptionsHtml: {
        tabSize: 4,
        styleActiveLine: false,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
        mode: 'text/html',
        hintOptions: {
          completeSingle: false
        },
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: { Ctrl: 'autocomplete' },
        autoCloseTags: true,
        autoCloseBrackets: true
      },
      cmOptionsCss: {
        tabSize: 4,
        styleActiveLine: false,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
        mode: 'text/css',
        hintOptions: {
          completeSingle: false
        },
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'monokai',
        extraKeys: { Ctrl: 'autocomplete' },
        autoCloseBrackets: true
      }
    }
  },
  computed: {
    ...mapGetters(['getHtmlPageVersion']),
    htmlPageVersion () {
      return this.getHtmlPageVersion(this.id)
    },
    headContent: {
      get: function () {
        return this.htmlPageVersion.headContent
      },
      set: function (value) {
        const payload = {
          versionId: this.id,
          headContent: value
        }
        this.$store.commit('UPDATE_HTML_PAGE_VERSION_HEAD_CONTENT', payload)
      }
    },
    cssContent: {
      get: function () {
        return this.htmlPageVersion.cssContent
      },
      set: function (value) {
        const payload = {
          versionId: this.id,
          cssContent: value
        }
        this.$store.commit('UPDATE_HTML_PAGE_VERSION_CSS_CONTENT', payload)
      }
    },
    bodyContent: {
      get: function () {
        return this.htmlPageVersion.bodyContent
      },
      set: function (value) {
        const payload = {
          versionId: this.id,
          bodyContent: value
        }
        this.$store.commit('UPDATE_HTML_PAGE_VERSION_BODY_CONTENT', payload)
      }
    }
  },
  methods: {
    inputted () {
      if (!this.htmlPageVersion.notUpdated) {
        this.$emit('not-updated-html-page-version', this.htmlPageVersion.id)
      }
    }
  }
}
</script>
<style>
.html_page_edit_css {
  outline-width: 0px;
  margin: 0px;
  border-radius: 5px;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  overflow: visible auto;
  list-style: none;
  border: thin solid rgba(0, 0, 0, 0.12);
}
.codemirror_html_body_css .CodeMirror {
  height: 650px;
}
</style>
